import Banner from '@ben/orion/banner';
import Button from '@ben/orion/button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

export interface BeneficiariesEmptyStateProps {
  // Whether anyone is offered for quick-add; the explainer copy changes.
  hasPickerRows: boolean;
  disabled?: boolean;
  onAddClick: () => void;
  children?: ReactNode;
}

const BeneficiariesEmptyState = ({
  hasPickerRows,
  disabled,
  onAddClick,
  children,
}: BeneficiariesEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Banner
        variant="amber"
        title={t('benefit.beneficiariesMissingTitle')}
        message={t('benefit.beneficiariesMissingMessage')}
      />
      <ExplainerCard>
        <Typography variant={TypographyVariant.bodyLg1}>
          {t(
            hasPickerRows
              ? 'benefit.beneficiariesDependantsExplainer'
              : 'benefit.beneficiariesEmptyExplainer'
          )}
        </Typography>
        {children}
        <Button
          type="button"
          variant="primary"
          disabled={disabled}
          onClick={onAddClick}
        >
          {t('benefit.beneficiariesAddButton')}
        </Button>
      </ExplainerCard>
    </>
  );
};

export default BeneficiariesEmptyState;

const ExplainerCard = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2.5, 3)};
    background-color: ${theme.palette.neutral[40]};
    border: 1px solid ${theme.palette.neutral[60]};
    border-radius: ${theme.borderRadius.sm};
  `}
`;
